// Cooldown identity for OTP requests. One module builds the keys so the write
// side (the API layer stamping a successful send) and the read side (the
// screens showing a countdown) can never drift into different formats.

import type { OTPType } from '@/api/endpoints/authApi';

/** How long a sent code blocks another request for the same key. */
export const OTP_COOLDOWN_MS = 120_000;

/** Phone OTP: one cooldown per flow per number. */
export const phoneOtpKey = (otpType: OTPType, countryCode: string, mobileNumber: string) =>
  `${otpType}:${countryCode}${mobileNumber}`;

/** Profile email verification — no phone; scoped to the signed-in address. */
export const emailOtpKey = (email: string) => `email_verification:${email}`;
